<template>
  <!-- 白色建筑 -->
  <div class="store" :class="{ storeMove: storeMoveNum != 0 }">
    <img src="../assets/images/in/0703-封面内页的副本-01.png" alt="" />
    <div class="addPage"></div>
    <div class="addPage reflact"></div>
    <!-- 化妆品广告 -->
    <div class="light1" @click="innerPage(1)">
      <div class="content mark-content">
        <div class="hidden-mark">
          <div class="hidden_content">
            <span class="ch">化妆品广告</span>
            <span class="en">Cosmetics advertising</span>
          </div>
        </div>
      </div>
      <div class="content mark-content reflact">
        <div class="hidden-mark">
          <div class="hidden_content">
            <span class="ch">化妆品广告</span>
            <span class="en">Cosmetics advertising</span>
          </div>
        </div>
      </div>
      <img src="../assets/images/in/0706-化妆品种类-下-02.png" alt="" />
    </div>

    <!-- 汽车广告 -->
    <div class="light2" @click="innerPage(2)">
      <div class="content car-content">
        <i class="iconfont icon-luosi"></i>
        <i class="iconfont icon-luosi"></i>
        <div class="car_p">
          <p class="ch">汽车类广告</p>
          <p class="en">Automobile advertising</p>
        </div>
      </div>
      <div class="content car-content reflact">
        <i class="iconfont icon-luosi"></i>
        <i class="iconfont icon-luosi"></i>
        <div class="car_p">
          <p class="ch">汽车类广告</p>
          <p class="en">Automobile advertising</p>
        </div>
      </div>

      <img src="../assets/images/in/0706-汽车种类-下-02.png" alt="" />
    </div>

    <!-- 快消类广告 -->
    <div class="light3" @click="innerPage(3)">
      <div class="content shop-content shop-content-up">
        <div class="fmcg_content">
          <span class="ch">快消类广告</span>
          <span class="en">FMCG advertising</span>
        </div>
      </div>
      <div class="content shop-content reflact">
        <div class="fmcg_content">
          <span class="ch">快消类广告</span>
          <span class="en">FMCG advertising</span>
        </div>
      </div>
      <img src="../assets/images/in/0706-快消种类-下-02.png" alt="" />
    </div>

    <!-- 酒类广告 -->
    <div class="light4" @click="innerPage(4)">
      <div class="content alcohol-content">
        <div class="alcohol_text">
          <span class="ch">酒类广告</span
          ><span class="en">Alcohol advertising</span>
        </div>
      </div>
      <div class="content alcohol-content reflact">
        <div class="alcohol_text">
          <span class="ch">酒类广告</span
          ><span class="en">Alcohol advertising</span>
        </div>
      </div>
      <img src="../assets/images/in/0706-酒类-下-02.png" alt="" />
    </div>

    <!-- 珠宝广告 -->
    <div class="light5" @click="innerPage(5)">
      <div class="content jewelry-content">
        <div class="jewelry_text">
          <span class="ch">珠宝类广告</span>
          <span class="en">Jewelry advertising</span>
        </div>
        <div class="jewelry_content_span">
          <span class="flash1"></span>
          <span class="flash2"></span>
          <span class="flash3"></span>
        </div>
      </div>
      <div class="content jewelry-content reflact">
        <div class="jewelry_text">
          <span class="ch">珠宝类广告</span>
          <span class="en">Jewelry advertising</span>
        </div>
        <div class="jewelry_content_span">
          <span class="flash1"></span>
          <span class="flash2"></span>
          <span class="flash3"></span>
        </div>
      </div>
      <img src="../assets/images/in/0706-珠宝类-下-02.png" alt="" />
    </div>

    <!-- 其他类广告 -->
    <div class="light6" @click="innerPage(6)">
      <div class="content other-content">
        <div class="o-wrap">
          <p class="ch">PR活动</p>
          <p class="en">Pr Events</p>
        </div>
      </div>
      <div class="content other-content reflact">
        <div class="o-wrap">
          <p class="ch">其他广告</p>
          <p class="en">Other advertisements</p>
        </div>
      </div>
      <img src="../assets/images/in/0706-其他-下-02.png" alt="" />
    </div>

    <!-- 音乐开发 -->
    <div class="light7" @click="innerPage(7)">
      <div class="content music-content">
        <p class="ch">
          <span>音</span><span>乐</span><span>制</span><span>作</span>
        </p>
        <p class="en">
          Music <br />
          production
        </p>
        <i class="iconfont icon-yinfu"></i>
        <i class="iconfont icon-iconset0163"></i>
        <i class="iconfont icon-yinfu1"></i>
        <i class="iconfont icon-icon--"></i>
        <i class="iconfont icon-yinfu show1"></i>
        <i class="iconfont icon-iconset0163 show2"></i>
        <i class="iconfont icon-yinfu1 show3"></i>
        <i class="iconfont icon-icon-- show4"></i>
      </div>
      <div class="content music-content reflact">
        <p class="ch">
          <span>音</span><span>乐</span><span>制</span><span>作</span>
        </p>
        <p class="en">
          Music <br />
          production
        </p>
        <i class="iconfont icon-yinfu"></i>
        <i class="iconfont icon-iconset0163"></i>
        <i class="iconfont icon-yinfu1"></i>
        <i class="iconfont icon-icon--"></i>
        <i class="iconfont icon-yinfu show1"></i>
        <i class="iconfont icon-iconset0163 show2"></i>
        <i class="iconfont icon-yinfu1 show3"></i>
        <i class="iconfont icon-icon-- show4"></i>
      </div>
      <img src="../assets/images/in/0706-音乐制作-下-02.png" alt="" />
    </div>
  </div>
</template>

<script>
import { Bus } from "../bus";
export default {
  data() {
    return {
      storeMoveNum: 0
    };
  },
  methods: {
    // 点击跳转到详情页
    innerPage(pageId) {
      let routeUrl = this.$router.resolve({
        path: "/innerpage",
        query: { pageId }
      });
      window.open(routeUrl.href, "_blank");

      Bus.$emit("pageId", pageId);
    }
  },
  created() {
    Bus.$on("liActiveNum", liActiveNum => {
      this.storeMoveNum = liActiveNum;
    });
  }
};
</script>

<style>
.store {
  z-index: 10;
  position: relative;

  -webkit-transition: 1s linear;

  transition: 1s linear;
  -webkit-transform: translateY(-26.4%);
  transform: translateY(-26.4%);
}

.storeMove {
  -webkit-transform: translateX(-100%) translateY(-26.4%);
  transform: translateX(-100%) translateY(-26.4%);
}

.store .addPage {
  position: absolute;
  bottom: 27.95%;
  left: 100%;
  height: 0.4%;
  width: 100%;
  background: #fff;
  opacity: 1;
}
.store .addPage::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 40%;
  background: #fff;
  top: -110%;
}
.store .addPage.reflact {
  -webkit-transform: scaleY(-1);
  transform: scaleY(-1);
  bottom: 27.57%;
  opacity: 0.6;
}
.store > img {
  width: 100%;
}
.store > div {
  position: absolute;
  opacity: 0;
  -webkit-transition: 0.3s linear;
  transition: 0.3s linear;
}
.store div:hover {
  opacity: 1;
}
.store div img {
  width: 100%;
}
.store .light1 {
  left: 6.6%;
  width: 10%;
  top: 48.8%;
}
.store .light2 {
  left: 14.6%;
  width: 15.2%;
  top: 63.79%;
}
.store .light3 {
  left: 27.4%;
  width: 15%;
  top: 58.4%;
}
.store .light4 {
  left: 44%;
  width: 11.5%;
  top: 50.7%;
}
.store .light5 {
  left: 56.8%;
  width: 12.7%;
  top: 54.9%;
}
.store .light6 {
  left: 70.55%;
  width: 9%;
  top: 44.9%;
}
.store .light7 {
  left: 78.72%;
  width: 14.5%;
  top: 50.8%;
}

.content {
  width: 100%;
  height: 100%;
}
.light1 .content {
  position: absolute;
  border: 1px solid #fff;
  width: 100%;
  height: 12%;
  top: -10%;
  left: 2%;
}
.light1 .content::after,
.light1 .content::before {
  content: "";
  position: absolute;
  width: 1%;
  height: 22%;
  background: #fff;
  bottom: -22%;
}
.light1 .content::before {
  left: 27%;
}
.light1 .content::after {
  right: 29%;
}
.light1 .content .hidden-content {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  overflow: hidden;
}
.light1 .content.reflact {
  -webkit-transform: scaleY(-1);
  transform: scaleY(-1);
  top: 97%;
  left: -1%;
  opacity: 0.2;
}

.store .content {
  position: absolute;
}
.store .content.reflact {
  opacity: 0.2;
  -webkit-transform: scaleY(-1);
  transform: scaleY(-1);
}
.light2 .content.reflact {
  top: 99%;
}

/* 化妆品广告 */
.mark-content {
  border: 1px solid white;
  left: -4%;
  top: -11.2%;
  width: 110%;
  height: 12%;
}
.mark-content .hidden-mark {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.hidden-mark .hidden_content {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  width: 100%;
  height: 100%;
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}
.mark-content .hidden_content .en {
  font-size: 0.8rem;
}
.light1:hover .mark-content .hidden_content {
  -webkit-animation: mark-height 0.7s linear forwards;
  animation: mark-height 0.7s linear forwards;
}
@-webkit-keyframes mark-height {
  from {
    -webkit-transform: translateY(50px) scale(0.8);
    transform: translateY(50px) scale(0.8);
  }
  to {
    -webkit-transform: translateY(0px) scale(0.8);
    transform: translateY(0px) scale(0.8);
    opacity: 1;
  }
}
@keyframes mark-height {
  from {
    -webkit-transform: translateY(50px) scale(0.8);
    transform: translateY(50px) scale(0.8);
  }
  to {
    -webkit-transform: translateY(0px) scale(0.8);
    transform: translateY(0px) scale(0.8);
    opacity: 1;
  }
}

/* 汽车类广告 */

.car-content {
  left: 0px;
  top: -36%;
  border: 1px solid white;
  background-color: #161f2b;
  border-radius: 1rem;
  width: 64%;
  height: 35%;
}
.car-content .car_p {
  position: absolute;
  -webkit-transform: scale(0.8);
  transform: scale(0.75);
  left: -8.5%;
}
.car-content p {
  margin: 6% 0;
  line-height: 1;
}
.car-content .ch {
  margin-top: 5%;
}
.car-content .en {
  font-size: 0.8rem;
}
.light2 i {
  position: absolute;
  right: 1%;
  top: 20%;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
  font-size: 0.8vw;
}
.light2 i:nth-child(2) {
  right: 15%;
}
.light2:hover i {
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}
.light2:hover .car_p {
  -webkit-animation: show_car 1s ease;
  animation: show_car 1s ease;
}
@-webkit-keyframes show_car {
  from {
    -webkit-transform: translateX(110px) scale(0.75);
    transform: translateX(110px) scale(0.75);
    opacity: 0;
  }
  to {
    -webkit-transform: translateX(0) scale(0.75);
    transform: translateX(0) scale(0.75);
  }
}
@keyframes show_car {
  from {
    -webkit-transform: translateX(110px) scale(0.75);
    transform: translateX(110px) scale(0.75);
    opacity: 0;
  }
  to {
    -webkit-transform: translateX(0) scale(0.75);
    transform: translateX(0) scale(0.75);
  }
}

/* 快消类广告 */
.light3 {
  -webkit-perspective: 300px;
  perspective: 300px;
}

.shop-content {
  border: 1px solid white;
  left: 20%;
  top: -9%;
  background-color: #161f2b;
  -webkit-transform-origin: bottom;
  transform-origin: bottom;
  box-sizing: border-box;
  width: 60%;
  height: 21.3%;
}
.shop-content .fmcg_content {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-content: center;
  -webkit-box-pack: center;
  justify-content: center;
  text-align: center;
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}
.shop-content .fmcg_content .en {
  font-size: 0.8rem;
}
.shop-content::before {
  content: "";
  position: absolute;
  left: -11%;
  bottom: 32%;
  background-color: white;
  width: 17%;
  height: 1%;
  -webkit-transform: rotate(-75deg);
  transform: rotate(-75deg);
}
@-webkit-keyframes shot_rotate {
  0% {
    -webkit-transform: rotateX(90deg);
    transform: rotateX(90deg);
  }
  100% {
    -webkit-transform: rotateX(0);
    transform: rotateX(0);
  }
}
@keyframes shot_rotate {
  0% {
    -webkit-transform: rotateX(90deg);
    transform: rotateX(90deg);
  }
  100% {
    -webkit-transform: rotateX(0);
    transform: rotateX(0);
  }
}
@-webkit-keyframes shot_rotate111 {
  0% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  100% {
    -webkit-transform: rotateX(180deg);
    transform: rotateX(180deg);
  }
}
@keyframes shot_rotate111 {
  0% {
    -webkit-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  100% {
    -webkit-transform: rotateX(180deg);
    transform: rotateX(180deg);
  }
}
.light3 .reflact {
  top: 66% !important;
}
.light3:hover .shop-content-up {
  -webkit-animation: shot_rotate 0.7s linear;
  animation: shot_rotate 0.7s linear;
}
.light3:hover .reflact {
  -webkit-animation: shot_rotate111 0.7s linear;
  animation: shot_rotate111 0.7s linear;
}

/* 酒类广告 */
.alcohol-content {
  right: -11%;
  bottom: 65.7%;
  overflow: hidden;
  width: 66%;
  height: 10%;
}

.alcohol-content .alcohol_text {
  text-align: center;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  line-height: 1;
  width: 100%;
  height: 100%;
  -webkit-transform: scale(0.75);
  transform: scale(0.75);
}
.alcohol-content .alcohol_text .en {
  font-size: 0.8rem;
}
.light4:hover .alcohol-content .alcohol_text {
  -webkit-animation: trans-alc-text 0.7s linear forwards;
  animation: trans-alc-text 0.7s linear forwards;
}
@-webkit-keyframes trans-alc-text {
  from {
    -webkit-transform: translateX(100px) scale(0.75);
    transform: translateX(100px) scale(0.75);
  }
  to {
    -webkit-transform: translateX(0px) scale(0.75);
    transform: translateX(0px) scale(0.75);
  }
}
@keyframes trans-alc-text {
  from {
    -webkit-transform: translateX(100px) scale(0.75);
    transform: translateX(100px) scale(0.75);
  }
  to {
    -webkit-transform: translateX(0px) scale(0.75);
    transform: translateX(0px) scale(0.75);
  }
}
.light4 .reflact {
  top: 65% !important;
}

/* 珠宝类广告 */
.jewelry-content {
  left: 9.5%;
  top: -14%;
  width: 100%;
  height: 15%;
}
.jewelry-content .jewelry_text {
  line-height: 1;
  text-align: center;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}

.jewelry-content .jewelry_text .en {
  font-size: 0.8rem;
}
.jewelry-content .jewelry_content_span {
  width: 16%;
  height: 45%;
  position: relative;
  margin: 0 auto;
}
.jewelry-content .jewelry_content_span span {
  position: absolute;
  width: 4%;
  background: white;
  border-radius: 5px;
  bottom: 20%;
}
.jewelry-content .jewelry_content_span .flash1 {
  left: 0;
  -webkit-transform: rotate(-30deg);
  transform: rotate(-30deg);
}
.jewelry-content .jewelry_content_span .flash2 {
  left: 47%;
}
.jewelry-content .jewelry_content_span .flash3 {
  right: 0;
  -webkit-transform: rotate(30deg);
  transform: rotate(30deg);
}
@-webkit-keyframes change-height {
  0% {
    height: 0%;
  }
  50% {
    height: 50%;
  }
  100% {
    height: 1%;
  }
}
@keyframes change-height {
  0% {
    height: 0%;
  }
  50% {
    height: 50%;
  }
  100% {
    height: 1%;
  }
}
.light5:hover .jewelry-content .jewelry_content_span > span {
  -webkit-animation: change-height ease-in-out 1s infinite;
  animation: change-height ease-in-out 1s infinite;
}
.light5:hover .jewelry_reflact .jewelry_content_span > span {
  -webkit-animation: change-height ease-in-out 1s infinite alternate;
  animation: change-height ease-in-out 1s infinite alternate;
}

.light5 .reflact {
  top: 98% !important;
}

/* 其他类广告 */
.other-content {
  left: 10%;
  top: -10%;
  border: 1px solid white;
  width: 110%;
  height: 10%;
  -webkit-animation: twinkling-other 1s linear infinite;
  animation: twinkling-other 1s linear infinite;
}
.other-content .o-wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;

  -webkit-transform: scale(0.75);

  transform: scale(0.75);
}
.other-content .ch {
  margin: 0;
}
.other-content .en {
  margin: 0;
}
.other-content::after,
.other-content::before {
  content: "";
  position: absolute;
  width: 1%;
  height: 25%;
  background-color: white;
  bottom: -25%;
}
.other-content::after {
  right: 37%;
}
.other-content::before {
  left: 36%;
}
.light6:hover .other-content .o-wrap {
  -webkit-animation: round-ad 1s linear forwards;
  animation: round-ad 1s linear forwards;
}
@-webkit-keyframes twilking {
  0% {
    box-shadow: 0 0 0px white;
  }
  50% {
    box-shadow: 0 0 5px white;
  }
  100% {
    box-shadow: 0 0 0px white;
  }
}
@keyframes twilking {
  0% {
    box-shadow: 0 0 0px white;
  }
  50% {
    box-shadow: 0 0 5px white;
  }
  100% {
    box-shadow: 0 0 0px white;
  }
}
@-webkit-keyframes round-ad {
  0% {
    -webkit-transform: translate(0, -20px) scale(0.75);
    transform: translate(0, -20px) scale(0.75);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate(0px, 0px) scale(0.75);
    transform: translate(0px, 0px) scale(0.75);
    opacity: 1;
  }
}
@keyframes round-ad {
  0% {
    -webkit-transform: translate(0, -20px) scale(0.75);
    transform: translate(0, -20px) scale(0.75);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate(0px, 0px) scale(0.75);
    transform: translate(0px, 0px) scale(0.75);
    opacity: 1;
  }
}
@-webkit-keyframes twinkling-other {
  0% {
    border: 1px solid white;
    box-shadow: 0 0 8px white;
  }
  100% {
    border-color: transparent;
  }
}
@keyframes twinkling-other {
  0% {
    border: 1px solid white;
    box-shadow: 0 0 8px white;
  }
  100% {
    border-color: transparent;
  }
}

.light6 .reflact {
  top: 99% !important;
}

/* 音乐制作 */
.music-content {
  left: 83%;
  top: 12%;
  width: 60%;
}
.music-content p {
  margin: 0;
  padding: 0;
  line-height: 21px;
}
.music-content .ch span {
  opacity: 0;
}
.music-content .en {
  font-size: 0.9rem;
  line-height: 1;
}
.music-content i {
  color: white;
  position: absolute;
  opacity: 0;
}
.music-content i:nth-child(3) {
  left: 5%;
}
.music-content i:nth-child(4) {
  left: 35%;
  top: 14%;
}
.music-content i:nth-child(5) {
  right: 28%;
  top: 10%;
}
.music-content i:nth-child(6) {
  right: 21%;
  top: 0%;
}
.music-content .show2 {
  left: 10%;
}
.music-content .show3 {
  left: 15%;
}
.music-content .show4 {
  left: 20%;
}
.light7:hover i {
  -webkit-animation: i-show 1s linear forwards;
  animation: i-show 1s linear forwards;
}
.light7:hover .show1 {
  -webkit-animation: i-show-flow 1.5s linear infinite;
  animation: i-show-flow 1.5s linear infinite;
}
.light7:hover .show2 {
  -webkit-animation: i-show-flow 1.5s linear infinite;
  animation: i-show-flow 1.5s linear infinite;
  -webkit-animation-delay: 2s;
  animation-delay: 2s;
}
.light7:hover .show3 {
  -webkit-animation: i-show-flow 1.5s linear infinite;
  animation: i-show-flow 1.5s linear infinite;
  -webkit-animation-delay: 3s;
  animation-delay: 3s;
}
.light7:hover .show4 {
  -webkit-animation: i-show-flow 1.5s linear infinite;
  animation: i-show-flow 1.5s linear infinite;
  -webkit-animation-delay: 4s;
  animation-delay: 4s;
}
.light7:hover .ch span:nth-child(1) {
  -webkit-animation: span-show 1s linear forwards;
  animation: span-show 1s linear forwards;
}
.light7:hover .ch span:nth-child(2) {
  -webkit-animation: span-show 1s linear forwards;
  animation: span-show 1s linear forwards;
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.light7:hover .ch span:nth-child(3) {
  -webkit-animation: span-show 1s linear forwards;
  animation: span-show 1s linear forwards;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}
.light7:hover .ch span:nth-child(4) {
  -webkit-animation: span-show 1s linear forwards;
  animation: span-show 1s linear forwards;
  -webkit-animation-delay: 1.5s;
  animation-delay: 1.5s;
}
@-webkit-keyframes span-show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes span-show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes i-show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes i-show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-webkit-keyframes i-show-flow {
  0% {
    bottom: -60px;
  }
  20% {
    -webkit-transform: scale(2);
    transform: scale(2);
    left: -10px;
  }
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
    left: 0;
  }
  70% {
    -webkit-transform: scale(2);
    transform: scale(2);
    left: 10px;
  }
  100% {
    bottom: 35px;
    opacity: 1;
  }
}

@keyframes i-show-flow {
  0% {
    top: 30px;
  }
  20% {
    -webkit-transform: scale(2);
    transform: scale(2);
    left: -10px;
  }
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
    left: 0;
  }
  70% {
    -webkit-transform: scale(2);
    transform: scale(2);
    left: 10px;
  }
  100% {
    top: -75px;
    opacity: 1;
  }
}

.light7 .reflact {
  top: -13% !important;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) and (max-width: 1450px) {
  html {
    font-size: 14px !important;
  }
  /* .store div .ch {
    font-size: 15px;
  } */
  /* div {
    font-size: 12px !important;
  } */
}
</style>
